import React, { useEffect, useState } from "react";
import AOS from "aos";
import { Helmet } from "react-helmet";
import { useHistory, NavLink } from "react-router-dom";
import { useDispatch } from "react-redux";
import PublicLayout from "web/components/PublicLayout";
import LandingFooter from "web/pages/public/landing-page/LandingFooter";
import GetQuoteComponent from "../StartPage/GetQuote";
import imgIcon1 from "../../../../assets/images/1self.svg";
import imgIcon2 from "../../../../assets/images/2manage.svg";
import imgIcon3 from "../../../../assets/images/3cost.svg";
import DigitalSupplier from "../../../../assets/images/Benefits.jpeg";
import SelfManagedIcon from "../../../../assets/images/1demo.svg";
import ManagedServicesIcon from "../../../../assets/images/1ManagedServices.svg";
import CustomizedSolutionsIcone from "../../../../assets/images/1CustomizedSolutions.svg";
import ButtonGroup from "../ButtonGroup";
import ManagedServices from "../ManagedServices";
import CustomizedSolutions from "../CustomizedSolutions";
import SelfManaged from "../SelfManaged";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import {
  Banner,
  Expertise,
  Operation,
  Container,
  Wrapper,
  BackButton,
} from "web/pages/public/landing-page/PalletBuyer/PalletBuyerStyled";
import { logoutAdmin } from 'redux/actions/admin';
import { logoutClearRedux } from 'redux/actions/auth';

const PalletBuyerSolution = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    let token = localStorage.getItem('token')
    let isAdminOrUserAccount = localStorage.getItem('accountType')
    if (isAdminOrUserAccount && token) {
      if (isAdminOrUserAccount === 'Admin') history.push('/admin')
      else history.push('/dashboard')
    } else {
      dispatch(logoutAdmin())
      dispatch(logoutClearRedux())
      localStorage.clear()
      sessionStorage.clear()
    }
  }, [])

  useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 320,
      once: true,
    });
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  let history = useHistory();
  // toggle div
  const [visibleDiv, setVisibleDiv] = useState("first");
  const showFirstDiv = () => {
    setVisibleDiv("first");
  };
  const showSecondDiv = () => {
    setVisibleDiv("second");
  };
  const showThirdDiv = () => {
    setVisibleDiv("third");
  };
  const showForthdDiv = () => {
    setVisibleDiv("forth");
  };
  const homepage = () => {
    history.push("/");
  };

  return (
    <>
      <Helmet title="PalletTrader | Pallet Buyer Solutions">
        <meta
          name="description"
          content="Discover PalletTrader’s buyer solutions for pricing, purchasing and managing your pallet needs. Streamline your pallet buying process and save time and costs today."
        />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href="https://www.pallettrader.com/pallet-buyer-solutions" />
      </Helmet>
      <Wrapper>
        {/* {visibleDiv === "first" && ( */}
        <PublicLayout transparentHeader={true}>
          <Container>
            <Wrapper>
              <Operation>
                <Banner>
                  <div className="quote">
                    <GetQuoteComponent />
                  </div>
                  <div
                    className="banner-text"
                    data-aos="fade-up"
                    data-aos-delay="100"
                  >
                    <h2>Tech Enabled.</h2>
                    <h2 className="mb-4">Supply Assured.</h2>
                    <p>
                      Powered by the largest digital network of vetted
                      suppliers, this is a one-stop shop for all your pallet
                      procurement needs.
                    </p>
                  </div>
                </Banner>
                <Expertise>
                  <section className="simplify_process">
                    <div className="simplify_process_titel">
                      <div>
                        <h2>
                          Your Needs. Our Expertise. A Spectrum of Options.
                        </h2>
                      </div>
                    </div>
                    <div className="box-3-wrp">
                      <div className="box-info">

                        <div className="text-bg">
                          <div data-aos="fade-up" data-aos-delay="100">
                            <h4>Self Service</h4>
                            <ul className="easy">
                              <li>Easy to Use Platform</li>
                              <li>Procurement & Order Management</li>
                              <li>
                                Access to the Largest Vetted Supplier Network
                              </li>
                              <li>Transparent Pricing & Availability</li>
                              <li>Detailed Analytics for Better Decisions</li>
                            </ul>

                            <button>
                              <NavLink to="/self-managed-services">LEARN MORE</NavLink>
                            </button>
                          </div>
                        </div>
                        <div className="img-bg">
                          <img src={imgIcon1} />
                        </div>
                      </div>
                      <div className="box-info">
                        <div className="text-bg">
                          <div data-aos="fade-up" data-aos-delay="100">
                            <h4>Managed Services</h4>
                            <ul className="dedicated">
                              <li>
                                Outsource Your Pallet Management to the Pros
                              </li>
                              <li>
                                New Suppliers & Incumbent Management Solutions
                              </li>
                              <li>Interactive Management Console</li>
                              <li>On-Demand KPIs & Order Visibility</li>
                              <li>Dedicated Account Representatives</li>
                            </ul>
                            <button>
                              <NavLink to="/managed-services">LEARN MORE</NavLink>
                            </button>

                          </div>
                        </div>
                        <div className="img-bg">
                          <img src={imgIcon2} />
                        </div>
                      </div>
                      <div className="box-info">
                        <div className="text-bg">
                          <div data-aos="fade-up" data-aos-delay="100">
                            <h4>Customized Services</h4>
                            <ul className="dedicated2">
                              <li>Whitewood & Rental Hybrid Management</li>
                              <li>Repair & Return Programs (R&R)</li>
                              <li>Deposit & Redemption Programs</li>
                              <li>Custom Developed Solutions</li>
                              <li>
                                Value Engineering & Continuous Improvement
                              </li>
                            </ul>

                            <button>
                              <NavLink to="/customized-pallet-solutions">LEARN MORE</NavLink>
                            </button>
                          </div>
                        </div>
                        <div className="img-bg">
                          <img src={imgIcon3} />
                        </div>
                      </div>
                    </div>
                  </section>
                </Expertise>
                <section className="our_expertise mb-0">
                  <div className="expertise_overlay operation">
                    <div data-aos="fade-up" data-aos-delay="100">
                      <h2>Streamline Your Operation.</h2>
                      <h2 className="max-w">
                        Say Goodbye to Fragmented Processes and Limited
                        Visibility.
                      </h2>
                      <p className="max-w">
                        No matter which service fits you, our ultimate goal is
                        to bring ultimate value to your supply chain.
                      </p>
                      <button className="Homepage" onClick={homepage}>
                        TAKE ME TO THE BENEFITS
                      </button>
                    </div>
                    <div className="digital_supplier_img">
                      {/* <img
                          src={DigitalSupplier}
                          alt="icon"
                          data-aos="fade-down"
                          data-aos-delay="100"
                        /> */}
                      {/* <button onClick={() => {history.push('/')}}>Take Me to the Benefits</button> */}
                    </div>
                  </div>
                </section>
                <section className="Procurement_Solutions">
                  <div
                    className="hedding-wrp"
                    data-aos="fade-up"
                    data-aos-delay="100"
                  >
                    <h2>Pallet Procurement Solutions Built for You.</h2>
                    <p>
                      PalletTrader provides innovative tools to streamline and
                      optimize your pallet procurement process, ensuring
                      efficiency and effectiveness at every step.
                    </p>
                  </div>
                  <div className="Solutions_box">
                    <div className="gry-bg">
                      <img
                        src={SelfManagedIcon}
                        alt="icon"
                        data-aos="fade-up"
                        data-aos-delay="100"
                      />
                    </div>
                    <div className="blue-bg">
                      <div data-aos="fade-down" data-aos-delay="100">
                        <h4 className="manage">Self Service. </h4>
                        <h4>Control. Convenience. Choice.</h4>
                        <p>
                          Handle your pallet procurement and order management
                          independently with our user friendly platform. Full
                          control and transparency at your fingertips.
                        </p>
                        <button>
                          <NavLink to="/self-managed-services">GO TO SELF SERVICE</NavLink>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="Solutions_box mid-part">
                    <div className="blue-bg">
                      <div data-aos="fade-down" data-aos-delay="100">
                        <h4 className="manage">Managed Services.</h4>
                        <h4>We Do the Work,</h4>
                        <h4>You Get the Assurance.</h4>
                        <p>
                          Our end-to-end managed services ensure smooth and
                          efficient pallet management. Focus on your core
                          business while we take care of the rest.
                        </p>
                        <button>
                          <NavLink to="/managed-services"> GO TO MANAGED SERVICES</NavLink>
                        </button>
                      </div>
                    </div>
                    <div className="gry-bg">
                      <img
                        src={ManagedServicesIcon}
                        alt="icon"
                        data-aos="fade-up"
                        data-aos-delay="100"
                      />
                    </div>
                  </div>
                  <div className="Solutions_box mb-0">
                    <div
                      className="gry-bg"
                      data-aos="fade-up"
                      data-aos-delay="100"
                    >
                      <img src={CustomizedSolutionsIcone} alt="icon" />
                    </div>
                    <div className="blue-bg">
                      <div data-aos="fade-down" data-aos-delay="100">
                        <h4 className="manage">Customized Solutions.</h4>
                        <h4>Where Innovation Meets Efficiency.</h4>
                        <p>
                          Tailored solutions developed through collaboration
                          to perfectly fit your pallet category needs.
                        </p>
                        <button>
                          <NavLink to="/customized-pallet-solutions">GO TO CUSTOMIZED SOLUTIONS</NavLink>
                        </button>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  className="search_marketplace"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  <h2>Search the Marketplace. Request a Quote.</h2>
                  <h2>Experience Innovation.</h2>
                  <div className="experience">
                    <ButtonGroup />
                  </div>
                </section>
              </Operation>
            </Wrapper>
          </Container>

          <LandingFooter
            showThirdDiv={showThirdDiv}
            showSecondDiv={showSecondDiv}
            showForthdDiv={showForthdDiv}
          />
        </PublicLayout>
        {/* )} */}

        {/* {visibleDiv === "second" && (
          <div>
            <BackButton onClick={showFirstDiv}>
              <ArrowBackIcon />
            </BackButton>
            <ManagedServices />
          </div>
        )}
        {visibleDiv === "third" && (
          <div>
            <BackButton onClick={showFirstDiv}>
              <ArrowBackIcon />
            </BackButton>
            <CustomizedSolutions />
          </div>
        )}
        {visibleDiv === "forth" && (
          <div>
            <BackButton onClick={showFirstDiv}>
              <ArrowBackIcon />
            </BackButton>
            <SelfManaged />
          </div>
        )} */}
      </Wrapper>
    </>
  );
};

export default PalletBuyerSolution;
